const exportNs = {
  exportCsv: "Экспорт CSV",
  exporting: "Экспорт...",
  exportSuccess: "Файл успешно загружен",
  exportError: "Ошибка экспорта",
  exportEmpty: "Нет данных для экспорта",
  noData: "Нет данных для экспорта",
} as const;
export default exportNs;
